import { createAction } from "@reduxjs/toolkit";
import {
  uploadFileActionTypes,
  uploadMultipartFailureActionTypes,
} from "./actionTypes";

export const uploadMultipartFailure = createAction(
  uploadMultipartFailureActionTypes,
  (payload) => ({
    payload,
  }),
);

export const uploadFile = createAction(uploadFileActionTypes.request);

export const uploadFileSuccess = createAction(
  uploadFileActionTypes.success,
  (payload) => ({ payload }),
);
